// extracted by mini-css-extract-plugin
export var sliderRange = "_mq-2";
export var sliderRoot = "_mq-0";
export var sliderThumb = "_mq-3";
export var sliderTrack = "_mq-1";